import React from 'react';
import { projects } from '../shared/projects';
import { Link } from 'react-router-dom';
import { toProjectSlug } from '../utils/projectSlug';

const ProjectsDetail: React.FC = () => {
  return (
    <div className="pt-16 pb-8 flex justify-center">
      <div className="max-w-2xl w-full px-4 sm:px-6 lg:px-8">
        <div className="space-y-4">
          <div className="mb-2">
            <Link 
              to="/" 
              className="text-base text-minimal-grey hover:text-minimal-red transition-colors"
            >
              ← Back
            </Link>
            <h1 className="text-4xl font-medium text-minimal-grey mt-2 mb-1">Projects</h1>
          </div>

          <div className="space-y-6">
            {projects.map((project, index) => {
              const projectSlug = toProjectSlug(project);
              
              return (
                <div key={index} className="space-y-2">
                  <div className="flex items-center justify-between">
                    <Link 
                      to={`/projects/${projectSlug}`}
                      className="text-2xl font-medium text-minimal-red hover:underline"
                    >
                      {project.title}
                    </Link>
                    <span className="text-sm text-minimal-grey-dark">{project.period}</span>
                  </div>
                  
                  <p className="text-base text-minimal-grey leading-normal">
                    {project.shortDescription || project.description}
                  </p>

                  {index < projects.length - 1 && (
                    <div className="border-t border-minimal-grey-darker pt-4 mt-4"></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsDetail;

